import React from 'react';
import { useTranslation } from 'react-i18next';
import GoogleMap from '../components/GoogleMap';
import '../styles/Contact.css';

const Contact: React.FC = () => {
  const { t, i18n } = useTranslation();
  const dir = i18n.dir();
  return (
    <div className="contact-page">
      <div className="contact-section" dir={dir}>
        <div className="contact-header">
          <h2 className="contact-title">{t('home.contact.title')}</h2>
          <p className="contact-subtitle">{t('home.contact.subtitle')}</p>
        </div>

        <div className="contact-grid">
          {/* Contact Information */}
          <div className="contact-info-card">
            <h3 className="contact-info-title">{t('home.contact.info.title')}</h3>
            <div className="contact-info-list">
              <div className="contact-info-item">
                <span className="contact-info-label">{t('home.contact.info.address')}</span>
                <span className="contact-info-value">
                  Beta Kalıp Dizayn Tasarım<br />
                  Çobançeşme, Mithatpaşa Cd.<br />
                  Bahçelievler/Istanbul 34196<br />
                  <a 
                    href="https://maps.app.goo.gl/FrtzRENH5pQsahxz6"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-info-link"
                  >
                    {t('home.contact.info.viewMap')}
                  </a>
                </span>
              </div>
              <div className="contact-info-item">
                <span className="contact-info-label">{t('home.contact.info.phone')}</span>
                <a href="tel:+905373053426" className="contact-info-link" dir="ltr">+90 537 305 3426</a>
              </div>
              <div className="contact-info-item">
                <span className="contact-info-label">{t('home.contact.info.email')}</span>
                <span className="contact-info-value" dir="ltr">info@betajewelry.com</span>
              </div>
              <div className="contact-info-item">
                <span className="contact-info-label">{t('home.contact.info.workingHours')}</span>
                <span className="contact-info-value">
                  {t('home.contact.info.hours.weekdays')}<br />
                  {t('home.contact.info.hours.saturday')}<br />
                  {t('home.contact.info.hours.sunday')}
                </span>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-card">
            <h3 className="contact-form-title">{t('home.contact.form.title')}</h3>
            <form className="contact-form">
              <div className="contact-form-group">
                <label htmlFor="name" className="contact-form-label">{t('home.contact.form.name')}</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="contact-form-input"
                />
              </div>
              <div className="contact-form-group">
                <label htmlFor="email" className="contact-form-label">{t('home.contact.form.email')}</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="contact-form-input"
                />
              </div>
              <div className="contact-form-group">
                <label htmlFor="message" className="contact-form-label">{t('home.contact.form.message')}</label>
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  className="contact-form-input"
                />
              </div>
              <div className="contact-form-group">
                <button
                  type="submit"
                  className="contact-form-button"
                >
                  {t('home.contact.form.send')}
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Google Map */}
        <div className="contact-map">
          <GoogleMap address="İstanbul, Türkiye" />
        </div>
      </div>
    </div>
  );
};

export default Contact; 